import React from 'react'
import styled from '@emotion/styled'
import { useClipboard } from 'use-clipboard-copy'
import { Tooltip, Icon } from 'antd'
import { Ellipsis, EllipsisTooltip } from 'components'
import { colors } from 'style/theme'
import { usePayment } from 'context/payment-context';

const Selector = styled.div({
	fontSize: 14,
	display: 'grid',
	gridTemplateColumns: `40px auto`,
	cursor: "pointer"
})

const CopyToClipboard = styled(Icon)({
	fontSize: '1rem',
	color: colors.brandTextLight
})

const CopyToClipboardMessage = styled.div({
	fontSize: '0.6rem',
	fontWeight: 700,
	textTransform: 'uppercase',
	color: colors.brandTextLight
})

const NotAllowedSelector = styled.div({
	fontSize: 14,
	cursor: "pointer",
	color: 'gray',
	marginLeft: 40
})

export const SelectorNotAllowedInTrial = ({selector}) => {
	const {setPaymentModalOpen} = usePayment();

	return (
		<NotAllowedSelector onClick={() => setPaymentModalOpen(true, "selector")}>{selector}</NotAllowedSelector>
	)
}

const SelectorColumn = ({ selector, cls }) => {
	const clipboard = useClipboard({ copiedTimeout: 600 })
	const handleClick = React.useCallback(() => {
		clipboard.copy(selector)
	}, [clipboard, selector])
	return (
		<Selector type="copy" onClick={handleClick} >
			{ selector!=="-" && <CopyToClipboardMessage>{clipboard.copied ? 'Copied' : <CopyToClipboard type="copy" />}</CopyToClipboardMessage>}
			<Ellipsis width={'100%'}>
				<Tooltip placement="bottom" title={<EllipsisTooltip>{selector}</EllipsisTooltip>}>
					<span className={cls} ref={clipboard.target}>{selector}</span>
				</Tooltip>
			</Ellipsis>
		</Selector>
	)
}

export default SelectorColumn
